import { render, staticRenderFns } from "./PSDatePicker.vue?vue&type=template&id=5c4adda0&scoped=true&"
import script from "./PSDatePicker.vue?vue&type=script&lang=js&"
export * from "./PSDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4adda0",
  null
  
)

export default component.exports